const searchModal = document.querySelector('.Search.Modal');
if (!searchModal) return;
const buttons = searchModal.querySelectorAll('.Search__Results-Tab button');
const objectTypeInput = searchModal.querySelector('input[name="type"]');

if (buttons.length > 0) {
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      searchModal.querySelectorAll('.Search__Results-Tab button').forEach((otherButton) => {
        otherButton.classList.remove('active');
      });
      button.classList.add('active');

      searchModal.querySelectorAll('#predictive-search-results div').forEach((content) => {
        content.classList.remove('active');
      });
      const SearchTypeElement = searchModal.querySelector('.' + button.value);
      SearchTypeElement.classList.add('active');

      const activeObjectType = button.dataset.objectType;
      if (objectTypeInput && activeObjectType) objectTypeInput.value = activeObjectType;
    });
  });
}
